import {
  LoggedUser,
  Recruitment,
  User,
  hasOwner,
  recruitmentStatusByCode,
  recruitmentStatusConfig,
  isOwner,
} from 'entities';

type BaseRecruitment = Pick<Recruitment, 'status' | 'id'> & {
  owner: User;
};

export interface RecruitmentActions {
  canDeny: boolean;
  canFinish: boolean;
  canAssign: boolean;
}

export function getRecruitmentActions(
  recruitment: BaseRecruitment | undefined | null,
  loggedUser: LoggedUser,
): RecruitmentActions {
  if (!recruitment) return { canDeny: false, canFinish: false, canAssign: false };

  const isLeader = loggedUser.type === 'LEADER';
  const sameTeam = recruitment.owner.team === loggedUser.team.id;

  const isTeamLeader = sameTeam && isLeader;

  return {
    canDeny: [
      recruitmentStatusByCode[recruitment.status].canBeDenied,

      loggedUser.team.isRecruitmentTeam,

      hasOwner(recruitment) ? isTeamLeader || isOwner(recruitment, loggedUser) : isLeader,
    ].every(Boolean),

    canFinish: [
      recruitmentStatusByCode[recruitment?.status].canBeFinished,

      isOwner(recruitment, loggedUser) || isTeamLeader,
    ].every(Boolean),

    canAssign: [
      recruitmentStatusByCode[recruitment.status].canChangeOwner,

      recruitment.status === recruitmentStatusConfig.unassigned.code ? true : sameTeam,

      isLeader,
    ].every(Boolean),
  };
}
